import { render, staticRenderFns } from "./contract_list_pc.vue?vue&type=template&id=2cb118c6&scoped=true&"
import script from "./contract_list_pc.vue?vue&type=script&lang=js&"
export * from "./contract_list_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb118c6",
  null
  
)

export default component.exports